module.exports = __webpack_public_path__ + "img/download_yaocao.329f9d60.png";